import React from 'react';
import './About.css';

class About extends React.Component {
    render() {
        return (
            <div className='about'>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Et dolor sint, reiciendis vero excepturi ipsam ab qui! Placeat, cupiditate a, sint ullam distinctio tempore impedit corrupti id voluptate eaque harum!</p>
            </div>
        )
    }
}

export default About;